import 'particles.js'
import { gsap } from 'gsap'

export default class Particles {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.instance = ''
    this.id = ''
    this.shapeStroke = this.el.dataset.shapestroke
    this.opacity = this.el.dataset.opacity
    this.shapeFill = this.el.dataset.shapefill
    this.shapeOpacity = this.el.dataset.shapeopacity
    this.lineOpacity = this.el.dataset.lineopacity
    this.lineStroke = this.el.dataset.linestroke
    this.size = 20
  }

  init() {
    this.checkConfig()
    this.handleUniqueInstance()
    this.handleObserver()
  }

  handleObserver() {
    const options = {}
    const observer = new IntersectionObserver(
      this.handleIntersection,
      options,
    )
    observer.observe(this.el)
  }

  handleIntersection = (entries) => {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        this.createParticles()
      } else {
        this.fadeOut() // if not in window, destroy to save CPU
      }
    })
  }

  handleUniqueInstance() {
    const instances = document.querySelectorAll('[data-module="Particles"]')

    instances.forEach((instance, index) => {
      if (instance === this.el) {
        this.instance = this.el
        const target = this.el.querySelector('[data-target]')
        this.id = `ParticleInstance-${index}`
        if (target === null) {
          console.log('particle module missing target')
          return
        }
        target.setAttribute('id', this.id)

        this.el.classList.add(`particle-instance--${index}`)
      }
    })
  }

  checkConfig() {
    if (!this.opacity) {
      this.opacity = 0.3
    }
    if (!this.shapeFill) {
      this.shapeFill = '#ffffff'
    }
    if (!this.shapeStroke) {
      this.shapeStroke = '#ffffff'
    }
    if (!this.shapeOpacity) {
      this.shapeOpacity = 0.3
    }
    if (!this.lineOpacity) {
      this.lineOpacity = 0.2
    }
    if (!this.lineStroke) {
      this.lineStroke = this.shapeFill
    }
  }

  fadeIn() {
    const particleTl = gsap.timeline({
      defaults: { duration: 5, opacity: 0, ease: 'back' },
    })

    particleTl.fromTo(
      this.el,
      {
        opacity: 0,
      },
      {
        opacity: this.opacity,
      },
    )
  }

  fadeOut = () => {
    const particleTlOut = gsap.timeline({
      defaults: { duration: 0.2, opacity: 0, ease: 'back' },
    })

    particleTlOut.to(this.el, {
      opacity: 0,
    })
    particleTlOut.eventCallback('onComplete', this.handleDestroy)
  }

  handleDestroy() {
    if (window.pJSDom instanceof Array && window.pJSDom.length) {
      for (let i = 0; i < window.pJSDom.length; i++) {
        console.log(i)
        cancelRequestAnimFrame(pJSDom[i].pJS.fn.checkAnimFrame)
        cancelRequestAnimFrame(pJSDom[i].pJS.fn.drawAnimFrame)
        pJSDom[i].pJS.fn.particlesEmpty()
        pJSDom[i].pJS.fn.canvasClear()
      }
    }
  }

  createParticles = () => {
    if (!window.pJSDom) {
      window.pJSDom = []
    }
    this.fadeIn()
    particlesJS(this.id, {
      particles: {
        number: {
          value: 80,
          density: {
            enable: true,
            value_area: 610,
          },
        },
        color: {
          value: this.shapeFill,
        },
        shape: {
          type: 'polygon',
          stroke: {
            width: 0,
            color: this.shapeStroke,
          },
          polygon: {
            nb_sides: 6,
          },
        },
        opacity: {
          value: this.shapeOpacity,
          random: true,
          anim: {
            enable: false,
            speed: 1,
            opacity_min: 0.1,
            sync: false,
          },
        },
        size: {
          value: this.size,
          random: true,
          anim: {
            enable: false,
            speed: 40,
            size_min: 0.1,
            sync: false,
          },
        },
        line_linked: {
          enable: true,
          distance: 150,
          color: '#ffffff',
          opacity: this.lineOpacity,
          width: 1,
        },
        move: {
          enable: true,
          speed: 1,
          direction: 'none',
          random: false,
          straight: false,
          out_mode: 'out',
          bounce: false,
          attract: {
            enable: false,
            rotateX: 600,
            rotateY: 1200,
          },
        },
      },
      interactivity: {
        detect_on: 'window',
        events: {
          onhover: {
            enable: false,
            mode: 'bubble',
          },
          onclick: {
            enable: false,
            mode: 'push',
          },
          resize: true,
        },
        modes: {
          grab: {
            distance: 400,
            line_linked: {
              opacity: 1,
            },
          },
          bubble: {
            distance: 400,
            size: this.size * 1.05,
            duration: 2,
            opacity: 0.2,
            speed: 3,
          },
          repulse: {
            distance: 200,
            duration: 0.4,
          },
          push: {
            particles_nb: 4,
          },
          remove: {
            particles_nb: 2,
          },
        },
      },
      retina_detect: true,
    })
  }
}
